import React, { useState, useEffect } from 'react';
import Header from '../../component/layout/Header';
import Footer from '../../component/layout/Footer';
import Page from '../../component/utility/Page';
import DataTable from 'react-data-table-component';
import { custTableStyles } from '../../style/color';
import axios from 'axios';
import { mainurl } from '../../Mainurl';
import Switch from '@mui/material/Switch';
import { notification } from '../../component/hocs/notification';
import AddUser from '../../component/utility/master/AddUser';
import AssignUser from '../../component/utility/master/AssignUser';
import AssignUserView from '../../component/utility/master/AssignUserView';
import { Row, Col, Card, CardBody, Button, Input } from 'reactstrap';
import { FaEdit, FaPlusCircle, FaClipboardList } from 'react-icons/fa';

const UserManagement = () => {

    const [mode, setMode] = useState(1);
    const [loading, setLoading] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [originalData, setOriginalData] = useState([]);
    const [crrUser, setCrrUser] = useState('');
    const [selectedState, setSelectedState] = useState('0');
    const [stateOpt, setStateOpt] = useState('');

    useEffect(() => {
        get_state_list();
    }, []);

    const get_state_list = () => {
        let postData = [{ user_id: sessionStorage.getItem('user_id') }];

        axios({
            method: 'post',
            url: mainurl + 'Master/get_state_list2',
            data: postData,
            headers: { 'Content-Type': 'application/json' }
        })
            .then(function (response) {
                console.log("response", response.data);
                let list = response.data.map((row) => {
                    return <option value={row.state_code}>{row.state_name}</option>
                });
                setStateOpt(list);
            })
            .catch(() => {
                notification({
                    message: "State not found!",
                    type: 'error'
                })();
            });
    }

    const user_list = () => {
        setLoading(true);
        setTableData([]);

        if (selectedState == 0) {
            let notify = notification({ message: "Select state", type: 'warn' });
            notify();
            return false;
        }

        let postData = [{
            org_id: sessionStorage.getItem('org_id'),
            user_id: sessionStorage.getItem('user_id')
            , "state_id": selectedState
        }];

        axios({
            method: 'post',
            url: mainurl + 'Master/box_user_list',
            data: postData,
            headers: { 'Content-Type': 'application/json' }
        })
            .then(function (response) {

                console.log("USER LIST RESPONSE =>", response.data);

                let list = response.data.map((row, index) => {

                    let active = row.active_flag === "1";

                    return {
                        ids: index + 1,

                        // ✅ FIXED NAME (No Empty Brackets)
                        name: row.user_name_ne && row.user_name_ne.trim() !== ""
                            ? row.user_name + " (" + row.user_name_ne + ")"
                            : row.user_name,

                        user_id: row.user_code,

                        state: row.state_name || row.state || row.state_nm || "N/A",

                        login_id: row.user_code,
                        designation: row.role_desc,
                        active_flag: row.active_flag,

                        action: (
                            <div>
                                <FaEdit
                                    className='me-3 cursor'
                                    onClick={() => user_assign_view_handler(row)}
                                    color="#006600"
                                    size={20}
                                />
                                <Switch
                                    checked={active}
                                    onChange={() => active_deactive_handler(row)}
                                    size="small"
                                    color="success"
                                />
                            </div>
                        )
                    };
                });

                setOriginalData(list);
                setTableData(list);
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
            });
    };

    const handleStateChange = (e) => {
        const value = e.target.value;
        setSelectedState(value);
    };

    const user_assign_view_handler = (row) => {
        setCrrUser(row);
        setMode(4);
    };

    const back_handler = () => {
        setMode(1);
        user_list();
    };

    const active_deactive_handler = (row) => {

        let flag = row.active_flag === "1" ? 0 : 1;

        let postData = [{
            org_id: sessionStorage.getItem('org_id'),
            user_code: row.user_id,
            active_flag: flag
        }];

        axios({
            method: 'post',
            url: mainurl + 'Master/user_status_update',
            data: postData,
            headers: { 'Content-Type': 'application/json' }
        })
            .then(function () {
                user_list();
                notification({
                    message: "Status changed successfully",
                    type: 'success'
                })();
            })
            .catch(() => {
                user_list();
            });
    };

    return (
        <>
            <Header />
            <Page title='User Management' breadcrumbs='Home / User Management'>
                <Row className='p-3'>

                    {mode === 1 &&
                        <Col xs={12}>
                            <Card className='mb-3' color="primary" outline>
                                <CardBody>
                                    <Row>

                                        <Col md={3}>
                                            <Input
                                                type="select"
                                                bsSize="sm"
                                                value={selectedState}
                                                onChange={(e) => setSelectedState(e.target.value)}
                                                required
                                            >
                                                <option value="">--Select State--</option>
                                                {stateOpt}

                                            </Input>
                                        </Col>

                                        <Col md={2}>
                                            <Button
                                                className='text-white'
                                                color='primary'
                                                size="sm"
                                                block
                                                onClick={user_list}
                                            >
                                                <FaClipboardList className='me-1' size={18} />
                                                Get User List
                                            </Button>
                                        </Col>

                                        <Col md={2}>
                                            <Button
                                                className='text-white'
                                                color='primary'
                                                size="sm"
                                                block
                                                onClick={() => setMode(2)}
                                            >
                                                <FaPlusCircle className='me-1' size={18} />
                                                Add New User
                                            </Button>
                                        </Col>

                                    </Row>
                                </CardBody>
                            </Card>

                            <Card color="primary" outline>
                                <CardBody>
                                    <DataTable
                                        customStyles={custTableStyles}
                                        columns={[
                                            { name: 'Id', selector: row => row.ids, sortable: true, width: '80px' },
                                            { name: 'Name', selector: row => row.name },
                                            { name: 'User Id', selector: row => row.user_id },
                                            { name: 'State', selector: row => row.state },
                                            { name: 'Login Id', selector: row => row.login_id },
                                            { name: 'Designation', selector: row => row.designation },
                                            { name: 'Action', selector: row => row.action }
                                        ]}
                                        data={tableData}
                                        highlightOnHover
                                        progressPending={loading}
                                        pagination
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                    }

                    {mode === 2 &&
                        <Col xs={12}>
                            <AddUser back={() => back_handler()} reset={user_list} />
                        </Col>
                    }

                    {mode === 3 &&
                        <Col xs={12}>
                            <AssignUser back={() => back_handler()} />
                        </Col>
                    }

                    {mode === 4 &&
                        <Col xs={12}>
                            <AssignUserView user={crrUser} back={() => back_handler()} />
                        </Col>
                    }

                </Row>
            </Page>
            <Footer />
        </>
    );
};

export default UserManagement;